import {Params} from "@angular/router";
import * as moment from "moment";
import {TimeUtility} from "../../time.utility";
import {IParams} from "../../../../../../base/endpoints/iparams";

export interface FilterField {
  type: 'text' | 'number' | 'date' | 'dropdown';
  label: string;
  name: string;
  value: string | number | boolean | Date | null;
  placeholder?: string;
  options?: { label: string; value: string | number | boolean | Date }[];
}

export interface BasicFilterData {
  query: string | null
  fromDate: Date
  toDate: Date
  username: string | null
  page: number
  size: number
  sort_by: string
  sort_direction: string
  extra: IParams
}

export const defaultFilterData: BasicFilterData = {
  query: null,
  fromDate: TimeUtility.getDayStart(new Date(0)),
  toDate: TimeUtility.getDayEnd(new Date()),
  username: null,
  page: 0,
  size: 10,
  sort_by: "id",
  sort_direction: "DESC",
  extra: {}
}

export function defaultFilterDataWithExtra(extra: IParams): BasicFilterData {
  return {
    ...defaultFilterData,
    extra: extra
  }
}

export function toParams(filterData: BasicFilterData): IParams {
  return {
    query: filterData.query,
    username: filterData.username,
    from_date: filterData.fromDate.toISOString(),
    to_date: filterData.toDate.toISOString(),
    page: filterData.page,
    size: filterData.size,
    ...filterData.extra
  }
}

/*
* Parses the query params received from url to BasicFilterData object.
* @param params: Params object received from ActivatedRoute
* @param defaultSize: default size of the page
* @param extra: extra filter fields
 */
export function parseFilterData(params: Params, defaultSize: number = 10, extra: IParams = {}): BasicFilterData {
  let query = (params['query'] ?? null) as string | null;
  let username = params['username'] as string
  let fromDate: Date = new Date(0)
  let toDate: Date = TimeUtility.addMinutes(new Date(), 1)

  if (params['from_date'] != null && params['to_date'] != null) {
    fromDate = moment(params['from_date']).toDate();
    toDate = moment(params['to_date']).toDate();
  }

  return {
    query: query,
    fromDate: fromDate,
    toDate: toDate,
    username: username != null && username.length > 0 ? username : null,
    page: params['page'] ? params['page'] : 0,
    size: params['size'] ? params['size'] : defaultSize,
    sort_by: params['sort_by'] ? params['sort_by'] : '',
    sort_direction: (params['sort_direction'] ? params['sort_direction'] : '').toUpperCase(),
    extra: convert(extra, params, [
      'query', 'username', 'from_date', 'to_date', 'page', 'size'
    ])
  }
}

/*
* Converts the newParams received from url, to the existing IParam object,
* excluding the keys in exclusions (most common/basic filter params).
 */
// function convert(existing: IParams, newParams: Params, exclusions: string[]): IParams {
//   Object.keys(newParams).forEach((key) => {
//     if (!exclusions.includes(key)) {
//       const value = newParams[key];
//
//       if (typeof value === 'string') {
//         const parsedDate = Date.parse(value);
//         if (!isNaN(parsedDate)) {
//           existing[key] = new Date(parsedDate);
//         } else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
//           existing[key] = value.toLowerCase() === 'true';
//         } else if (!isNaN(Number(value))) {
//           existing[key] = Number(value);
//         } else {
//           existing[key] = value;
//         }
//       } else {
//         existing[key] = value;
//       }
//     }
//   });
//
//   return existing;
// }

function convert(existing: IParams, newParams: Params, exclusions: string[]): IParams {
  Object.keys(newParams).forEach((key) => {
    if (!exclusions.includes(key)) {
      const value = newParams[key];

      if (typeof value === 'string') {
        const parsedDate = Date.parse(value);
        if (!isNaN(parsedDate) && !/^\d+$/.test(value)) {
          existing[key] = new Date(parsedDate);
        } else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
          existing[key] = value.toLowerCase() === 'true';
        } else if (!isNaN(Number(value))) {
          existing[key] = Number(value);
        } else {
          existing[key] = value;
        }
      } else {
        existing[key] = value;
      }
    }
  });

  return existing;
}
